import {
    SilDeviceNested,
    SilDeviceNestedCreate,
    SilProjectDeviceNested,
    SilProjectDeviceNestedCreate,
} from "server/models"
import { SilDeviceFilter } from "client/utils"
import { POST, DELETE } from "client/store/utils"


export const LoadSilNestedDevicesByFilter = (filters: SilDeviceFilter) => (
    POST(
        "/silDeviceNested/getByFilter",
        JSON.stringify(filters),
    ).then((devices: SilDeviceNested[]) => devices)
)

export const LoadSilProjectNestedDevicesByFilter = (filters: SilDeviceFilter) => (
    POST(
        "/silProjectDeviceNested/getByFilter",
        JSON.stringify(filters),
    ).then((devices: SilProjectDeviceNested[]) => devices)
)

export const AddSilNestedDevice = (
    projectId: number,
    device: SilDeviceNestedCreate | SilProjectDeviceNestedCreate,
) => (
    POST(
        projectId
            ? "/silProjectDeviceNested/add"
            : "/silDeviceNested/add",
        JSON.stringify(device),
    )
)

export const DeleteSilNestedDevices = (
    projectId: number,
    parentDeviceId: number,
) => (
    DELETE(
        projectId
            ? `/silProjectDeviceNested/deleteAll/${parentDeviceId}`
            : `/silDeviceNested/deleteAll/${parentDeviceId}`,
    ).then((removedRows: number) => removedRows)
)
